import React from 'react';
import styled from 'styled-components';

type TProps = {
    mainText?: string;
    secondaryText?: string | JSX.Element;
};

const InfoWindowContent = ({ mainText, secondaryText }: TProps): JSX.Element => {
    return (
        <InfoWindowContainer>
            <b>{mainText}</b>
            {secondaryText}
        </InfoWindowContainer>
    );
};

const InfoWindowContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 12px;
    min-height: 28px;
    min-width: 76px;
    padding: 10px;
`;

export default InfoWindowContent;
